import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors, isOsMobile } from './../../util/util'

const defaultStyle = {
  underlayColor: Colors.HALF_WHITE,

  textStyle: {
    fontSize: 12,
    fontWeight: '500',
  } as TextProps,

  viewStyle: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 6,
    // paddingVertical: 3,
  } as BoxProps,

  item: {
    padding: 4,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,

  states: {
    normal: {
      iconStyle: {
        color: Colors.DARK_GREY,
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: Colors.PRIMARY_GREY,
        fontSize: 12,
        fontWeight: '500',
      } as TextProps,

      item: {
        backgroundColor: Colors.WHITE,
        borderBottomColor: Colors.WHITE,
        borderBottomWidth: 1,
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: Colors.PRIMARY,
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: Colors.PRIMARY,
      } as TextProps,

      item: {
        backgroundColor: Colors.HALF_WHITE,
        borderBottomColor: Colors.PRIMARY,
        borderBottomWidth: 1,
      } as BoxProps,
    },
  },
}

const hightLightStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '600',
    color: 'BRAND_PRIMARY_RED',
  } as TextProps,
  item: {
    paddingVertical: 12,
    paddingHorizontal: 8,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: Colors.DARK_GREY,
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: Colors.GREY_90,
        fontSize: 12,
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: Colors.WHITE,
        borderBottomColor: Colors.WHITE,
        borderBottomWidth: 1,
        p: 15,
      } as BoxProps,
    },
    selected: {
      iconStyle: {
        color: Colors.PRIMARY,
        size: 14,
      },

      textStyle: {
        color: 'BLUE',
      } as TextProps,

      item: {
        backgroundColor: Colors.PRIMARY_LIGHT,
      } as ViewStyle,
    },
  },
}

const recentPaymentsStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'LIGHT_BLACK',
  } as TextProps,
  item: {
    padding: 15,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: Colors.DARK_GREY,
        size: 19,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: Colors.PRIMARY_GREY,
        fontSize: 12,
        type: 'caption',
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: Colors.WHITE,
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: 'BLUE',
        size: 14,
      },

      textStyle: {
        color: 'BLUE',
        fontSize: 12,
        fontWeight: '600',
        type: 'caption',
      } as TextProps,

      item: {
        borderBottomColor: 'BLUE',
        borderBottomWidth: 2,
        bg: Colors.LIGHT_BLUE as ColorOptions,
      } as BoxProps,
    },
  },
}

const profileStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: Colors.PRIMARY_GREY,
  } as TextProps,
  item: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: Colors.DARK_GREY,
        size: 14,
        fontWeight: '600',
      } as TextProps,

      textStyle: {
        color: Colors.GREY_90,
        fontSize: 12,
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: Colors.WHITE,
        borderBottomColor: Colors.WHITE,
        borderBottomWidth: 1,
        p: 20,
      } as BoxProps,
    },
    selected: {
      iconStyle: {
        color: Colors.PRIMARY,
        size: 14,
      },

      textStyle: {
        color: isOsMobile() ? Colors.PRIMARY : 'BLUE',
        fontWeight: '600',
        fontSize: 12,
      } as TextProps,

      item: {
        pv: 16,
        ph: 20,
        backgroundColor: Colors.PRIMARY_LIGHT,
        borderBottomColor: isOsMobile() ? Colors.PRIMARY : 'BLUE',
        borderBottomWidth: 2,
      } as BoxProps,
    },
  },
}

const styles = {
  default: defaultStyle,
  highlights: hightLightStyle,
  recentPayments: recentPaymentsStyle,
  profile: profileStyle,
  arrow: {
    ...defaultStyle,
    underlayColor: Colors.GREY_SEPARATOR,
    item: {
      ...defaultStyle.item,
      padding: 0,
      width: 30,
      paddingLeft: 12,
    },
    states: {
      ...defaultStyle.states,
      normal: {
        ...defaultStyle.states.normal,

        iconStyle: {
          color: Colors.BLACK,
          size: 16,
          fontWeight: 700,
        },

        textStyle: {
          color: Colors.BLACK,
          fontSize: 12,
          fontWeight: '600',
        } as TextProps,

        item: {
          backgroundColor: Colors.WHITE,
          borderBottomColor: Colors.WHITE,
          borderBottomWidth: 0,
        } as BoxProps,
      },

      selected: {
        iconStyle: {
          color: Colors.GREY_SEPARATOR,
          size: 16,
          fontWeight: 700,
        },

        textStyle: {
          color: Colors.BLACK,
          fontSize: 12,
          fontWeight: '700',
        } as TextProps,

        item: {
          backgroundColor: Colors.WHITE,
          borderBottomWidth: 0,
        } as BoxProps,
      },
    },
  },
}

export default styles
